import React from 'react';
type Bonus = {
  title: string;
  image: string;
  alt: string;
  value: string;
};
const bonuses: Bonus[] = [{
  title: 'Planificador Anual de Ciencias',
  image: 'https://cdn.magicpatterns.com/uploads/ePsCX9zhztDjUb54N4meHU/Bono_1_biologia_.webp',
  alt: 'Portada del Planificador Anual de Ciencias',
  value: '$19'
}, {
  title: 'Banco de Evaluaciones y Rúbricas',
  image: 'https://cdn.magicpatterns.com/uploads/4n1krV1Sc5bas56Bd8DSoS/Bono_2_biolgia.webp',
  alt: 'Portada del Banco de Evaluaciones y Rúbricas Listas',
  value: '$27'
}, {
  title: 'Láminas para el Aula (pósters)',
  image: 'https://cdn.magicpatterns.com/uploads/dp29BNMKdS1MmvRPciJCq5/Bono_3_biologia_.webp',
  alt: 'Portada de Láminas para el Aula, pack de pósters',
  value: '$36'
}, {
  title: 'Juegos y Actividades Imprimibles',
  image: 'https://cdn.magicpatterns.com/uploads/azkVRxdSYAmMYt2xqt6TUy/Bono_4_biologia_.webp',
  alt: 'Portada de Juegos y Actividades Imprimibles',
  value: '$45'
}, {
  title: 'Experimentos en Casa para familias',
  image: 'https://cdn.magicpatterns.com/uploads/1QcZ3PpnyGZLSsECPM4yW5/Bono_5_biologia_2B.webp',
  alt: 'Portada de Experimentos en Casa, guía para las familias',
  value: '$19'
}];
export function BonusesSection() {
  return <section className="bg-brand-cream px-4 py-20 md:py-24" data-id="element-24" data-mp="7lqkoop4p195">
      <div className="mx-auto max-w-5xl" data-id="element-25" data-mp="cjs45aqgv2l5">
        <div className="mb-12 text-center" data-id="element-26" data-mp="cj0juw2bkra6">
          <p className="inline-flex rounded-full bg-brand-mint px-4 py-2 text-sm font-extrabold text-brand-green" data-id="element-27" data-mp="chz5oiq0boo8">
            Valorados en <span className="ml-1 line-through" data-id="element-28" data-mp="lblrbg0i3bjp">$146</span>
            <span className="ml-1 text-brand-greenDark" data-id="element-29" data-mp="le6s01p2blfv">— HOY GRATIS</span>
          </p>
          <h2 className="mt-4 font-display text-3xl font-black text-brand-greenDark md:text-4xl" data-id="element-30" data-mp="qaf1aygkwkf4">
            5 Bonos Exclusivos de Regalo
          </h2>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-31" data-mp="10afowwlhdmp4">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="relative overflow-hidden rounded-3xl border border-brand-green/10 bg-white p-5 shadow-sm" data-id="element-32" data-mp="am0h24utrn2h" data-mpi={index}>
              <span className="absolute right-4 top-4 z-10 rounded-full bg-brand-green px-3 py-1 text-[10px] font-black tracking-wider text-white shadow-sm" data-id="element-33" data-mp="kb1xfw5a86gz">
                GRATIS
              </span>
              <div className="overflow-hidden rounded-2xl bg-brand-mint" data-id="element-34" data-mp="tbqb2pqrk4tc">
                <img src={bonus.image} alt={bonus.alt} className="aspect-[4/3] w-full object-cover" data-id="element-35" data-mp="tdtcs71a3mdw" />
              </div>
              <div className="pt-5" data-id="element-36" data-mp="139wcl68nr8xo">
                <p className="mb-1 text-xs font-bold text-brand-gray" data-id="element-37" data-mp="138v150nqckff">BONO {index + 1}</p>
                <h3 className="font-display text-lg font-black leading-tight text-brand-greenDark" data-id="element-38" data-mp="yajqwotiw7wo">{bonus.title}</h3>
                <p className="mt-2 text-sm font-extrabold text-brand-green" data-id="element-39" data-mp="3522fo7viqy09">
                  {bonus.value} <span className="ml-1 font-medium text-brand-gray line-through" data-id="element-40" data-mp="3037x971grbgo">incluido</span>
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}